import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

const skills = [
  "Brand Strategy",
  "Creative Direction",
  "Campaign Ideation",
  "Consumer Psychology",
  "Luxury Marketing",
  "Content Architecture",
  "Editorial Styling",
  "PR & Media Relations",
  "Performance Media",
  "Client Success",
  "Digital Storytelling",
  "Growth Analytics",
];

export const Skills = () => {
  return (
    <section
      id="skills"
      className="relative border-t hairline py-24 md:py-40"
      data-testid="skills-section"
    >
      <div className="grid grid-cols-12 px-6 md:px-10 lg:px-14 mb-14">
        <div className="col-span-12 md:col-span-3 label">05 — Fluencies</div>
        <div className="col-span-12 md:col-span-9 font-serif text-4xl md:text-6xl text-ink mt-4 md:mt-0">
          <span>A </span>
          <span className="italic">quiet</span>
          <span> arsenal of disciplines.</span>
        </div>
      </div>

      <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-t hairline">
        {skills.map((s, i) => (
          <motion.li
            key={s}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: EASE, delay: (i % 4) * 0.05 }}
            className="border-b border-r hairline px-6 md:px-8 py-8 md:py-10"
            data-testid={`skill-item-${i}`}
          >
            <span className="label block mb-3">0{(i + 1).toString().padStart(2, "0").slice(-2)}</span>
            <span className="font-serif text-2xl md:text-3xl leading-tight">
              {s}
            </span>
          </motion.li>
        ))}
      </ul>
    </section>
  );
};

export default Skills;
